var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldTickFill = function SvgShieldTickFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "m10.9 15.1 5.7-5.7-1.05-1.025-4.575 4.575-2.525-2.525-1.1 1.1zm1.1 6.875q-3.5-.874-5.75-4.062T4 10.925V5.668a1 1 0 0 1 .649-.936l7-2.625a1 1 0 0 1 .702 0l7 2.625a1 1 0 0 1 .649.936v5.257q0 3.8-2.25 6.988T12 21.975"
  })));
};
export default SvgShieldTickFill;